import "./solicitudCarrera.scss";
import { Formik, Form, ErrorMessage, Field, FieldArray } from "formik";
//import Button from "../../components/atoms/buttons/Button";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import {
  // getBorrador,
  presentarSolicitud,
  updateSolicitudPresentada,
} from "../../components/services/ReconocimientoNivelService";
import { SpinnerCircleMini } from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { obtenerBorrador, sendBorradorZ9, updateBorradorZ9 } from "../../components/services/DatoPersonalService";
import { getDatosIhPersona } from "../../components/services/IhPersonaService";
import { getIhLocalidades, getIhMunicipios, getIhProvincias } from "../../components/services/IhService";

const SolicitudCarrera = () => {
  const [show, setShow] = useState({
    mensaje: false,
  });
  const params = useParams();


  //   const [isInitialRender, setIsInitialRender] = useState({
  //     personal: true,
  //     borrador: false,
  //   });
  const [datosPersona, setDatosPersona] = useState();
  const [provincias, setProvincias] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [loading] = useState(true);
  const [loadingBoton, setLoadingBoton] = useState(false);
  const [, setLoadingBotonSolicitar] = useState(false);
  const [disablePresentar, setDisablePresentar] = useState(false);
  const [user] = useLocalStorage("user", "");
  const [defaultDraftNameRef] = useState(
    `Borrador ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString("es-ES", { hour: '2-digit', minute: '2-digit', hour12: false })}`
  );
  // let navigate = useNavigate();

  //niv carrera solicitado valores a pelo
  const [funCarreraInterino] = useState([
    "A1", "A2", "C1", "C2", "E"
  ]);
  const [labFijoTemporal] = useState(["G I", "G II", "G III", "G IV", "G V"]);

  const [borrador, setBorrador] = useState(false);

  const [accesoConcurso] = useState(true);
  const dt = new Date();

  const [datos, setDatos] = useState({
    // nombreBorrador: `Borrador ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString([], {
    //   hour: '2-digit',
    //   minute: '2-digit',
    //   hour12: false,
    // })}`,
    nombreBorrador: "",
    codSolicitud: 0,
    nombre: "",
    ape1: "",
    ape2: "",
    dni: "",
    domicilio: "",
    cp: "",
    localidad: "",
    provincia: "",
    tlf: "",
    email: "",
    nivelSolicitado: "",
    funcionario: "",
    laboral: "",
    a1: false,
    a2: false,
    a3: false,
    doe: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    formacion: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    transferencia: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    participacion: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    estado: "",
    fechaCreacion: null,
    creado: "",
    fcreacion: null,
    fmodifica: null,
    modificado: "",
  });

  const [disableCombo, setDisableCombo] = useState({
    funcionario: false,
    laboral: false
  });

  const presentar = (valores) => {
    setLoadingBoton(true);
    presentarSolicitud(valores).then((data) => {


      setShow({
        mensaje: true,
        content: data,
        tipo: "tituloModal",
        boton: "Aceptar ",
        destinoAviso: null,
        destinoCerrar: "/carrera",
        stateParams: { solPresentada: true, codSolicitud: datos?.codSolicitud },
      });

      setLoadingBoton(false);
    });
  };

  const handleClose = (e) => {
    setShow(false);
  };

  //Elimina un objeto en concreto (index) de un array de objetos (general, setgeral), con un estado de carga(setGeneralMostrar)
  // const eliminarGeneral = (id, setGeneralMostrar, general, tipo) => {
  //   setGeneralMostrar(false);
  //   new Promise((resolve) => {
  //     general = general.filter((item) => item.id !== id);
  //     
  //     setDatos((prevState) => ({
  //       ...prevState,
  //       [tipo]: general,
  //     }));
  //     resolve();
  //   }).then(() => setGeneralMostrar(true));
  // };

  // const anadirInput = (datosInput, name) => {
  //   datosInput.push({
  //     id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
  //     value: "",
  //   });

  //   setDatos((prevState) => ({
  //     ...prevState,
  //   }));
  // };

  const mantenerBorrador = (datos) => {


    setDatos(datos);
    setDatos((prevState) => ({
      ...prevState,
      dni: `${datos.dni}${user.letniep}`,
      codSolicitud: datos?.codSolicitud,
    }));
  };

  // const cargarNombreBorrador = (e) => {
  //   setDatos((prevState) => ({
  //     ...prevState,
  //     nombreBorrador: e.target.value,
  //   }));
  // }
  // const [nomBorrador, setNomBorrador] = useState("");
  useEffect(() => {
    // const dt = new Date();

    //nuevo
    //   
    //   setDatos((prevState) => ({
    //     ...prevState,
    //     nombre: user.nombre,
    //     ape1: user.apellido1,
    //     ape2: user.apellido2,
    //     dni: `${user.niep}${user.letniep}`,
    //   }));
    //   setIsInitialRender({ personal: false, borrador: true });
    //   setLoading(true)

    //borrador
    // setIsInitialRender({ personal: false, borrador: false });
    //Si el usuario actual tiene ya un borrador hecho lo recoge

    // getBorrador(user.niep).then((data) => {
    //   
    //   if (params?.id) {
    //     setLoading(true);
    //   } else {
    //     setDatos((prevState) => ({
    //       ...prevState,
    //       ape1: user.apellido1,
    //       ape2: user.apellido2,
    //       nombre: user.nombre,
    //       dni: `${user.niep}`,
    //     }));

    getDatosIhPersona().then((data) => {

      setDatos((prev) => ({
        ...prev,
        ape1: data.apellido1 || "",
        ape2: data.apellido2 || "",
        nombre: data.nombre || "",
        cp: data?.cpostal || "",
        tlf: data.ntelefono || "",
        email: data.cemailcor || data.cemailper || "",
        domicilio: `${data?.dtipvia ?? ''} ${data?.dcalle ?? ''} ${data?.ncalle ?? ''} ${data?.npiso ?? ''}${data?.puerta ?? ''}`.trim(),
        dni: `${data?.letiniiep ?? ''}${data?.niep ?? ''}${data?.letfiniep ?? ''}`
      }));
      setDatosPersona(data);
    })

    //   setIsInitialRender({ personal: true, borrador: false });
    // setLoading(true);
    //   }
    // });

    if (params?.id) {
      obtenerBorrador(params.id, "z9").then((data) => {

        setDatos(data)
        setDatos((prevState) => ({
          ...prevState,
          dni: `${data.letiniiep ? data.letiniiep : ""}${data.dni}${data.letfiniep ? data.letfiniep : ""}`,
        }));
      })

    }

  }, [user, params]);

  useEffect(() => {


    if (datosPersona?.locmunprvpaicpaidom !== "") {
      getIhProvincias(parseInt(datosPersona?.locmunprvpaicpaidom)).then((data) => {


        setProvincias(data)

      });
    }
    if (datosPersona?.locmunprvpaicpaidom !== "" && datosPersona?.locmunprvcprodom !== "") {


      getIhMunicipios(
        datosPersona?.locmunprvpaicpaidom,
        datosPersona?.locmunprvcprodom
      ).then((data) => {



      });
    }
    if (
      datosPersona?.locmunprvpaicpaidom !== "" &&
      datosPersona?.locmunprvcprodom !== "" &&
      datosPersona?.locmuncmunicipio !== ""
    ) {
      getIhLocalidades(
        datosPersona?.locmunprvpaicpaidom,
        datosPersona?.locmunprvcprodom,
        datosPersona?.locmuncmunicipio
      ).then((data) => {
        if (!data.toString().startsWith("Error:")) {

          setLocalidades(data)
        }
      });
    }
  }, [datosPersona])

  useEffect(() => {
    if (datosPersona && provincias.length && localidades.length) {
      // Buscar la provincia por código
      const provincia = provincias.find(
        (prov) => prov.cprovincia === datosPersona.locmunprvcprodom
      );

      // Buscar la localidad por código
      const localidad = localidades.find(
        (loc) =>
          loc.cprovincia === datosPersona.locmunprvcprodom &&
          loc.cmunicipio === datosPersona.locmuncmunicipio &&
          loc.clocalidad === datosPersona.locclocalidad
      );

      setDatos((prev) => ({
        ...prev,
        provincia: provincia?.dprovincia || "",
        localidad: localidad?.dlocalidad || "",
      }));
    }
  }, [datosPersona, provincias, localidades]);

  useEffect(() => {
    // Solo si ya tenemos los datos cargados
    if (datos?.funcionario || datos?.laboral) {
      if (datos.funcionario !== "") {
        setDisableCombo({
          funcionario: false, // habilitar funcionario
          laboral: true       // deshabilitar laboral
        });
      } else if (datos.laboral !== "") {
        setDisableCombo({
          funcionario: true,  // deshabilitar funcionario
          laboral: false      // habilitar laboral
        });
      }
    } else {
      // Ninguno seleccionado → ambos habilitados
      setDisableCombo({
        funcionario: false,
        laboral: false
      });
    }
  }, [datos]);
  return (
    <>
      <Header></Header>
      <div
        className="container d-flex flex-column min-vh-100 card mt-5"
        id="inicio"
        role="main" data-landmark-index="4"
      >
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login ">
                <div className="tituloSolicitud">
                  <h2 className="tituloPagina text-center py-3">Anexo</h2>
                  <div className="d-flex align-items-center flex-column">
                    {/* <Titulo
                      titulo={
                        "SOLICITUD DE RECONOCIMIENTO DE NIVEL DE CARRERA PROFESIONAL HORIZONTAL (Ámbito Administración General)"
                      }
                      tipo={"tituloPagina subTituloPagina"}
                    /> */}
                    <h3 className="tituloPagina subTituloPagina fw-lighter">SOLICITUD DE RECONOCIMIENTO DE NIVEL DE CARRERA PROFESIONAL HORIZONTAL (Ámbito Administración General)</h3>
                    <p className="text-third-1">{datos.estado}</p>
                  </div>
                </div>

                <div className="infoSolicitud">
                  <div className="instrucciones my-3 mx-2 fw-bold">


                    <div className="d-flex flex-wrap align-items-center">
                      Antes de cumplimentar y enviar esta solicitud, deberá leer las instrucciones pinchando{" "}
                      <span
                        className="ps-1 verde cursorPointer underline bg-transparent border-none p-0"
                        style={{ display: "inline", whiteSpace: "wrap" }}
                        // onClick={() => {
                        //   window.open(
                        //     "/instruccionesSolicitudpopup",
                        //     "popupInstrucciones",
                        //     "width=800,height=600,resizable=yes,scrollbars=yes"
                        //   );
                        // }}
                        onClick={() => {
                            window.open("https://portalempleado.juntaex.es/w/tramite-z9-solicitud-carrera-instrucciones")
                        }}
                        onKeyDown={() => {
                            window.open("https://portalempleado.juntaex.es/w/tramite-z9-solicitud-carrera-instrucciones")
                        }}
                      >
                        aquí
                      </span>.
                    </div>




                  </div>

                  <p className="textoInfo p-2">
                    Al amparo de lo previsto en el Decreto 127/2021, de 17 de
                    noviembre, por el que se regula la carrera profesional
                    horizontal y la evaluación del desempeño de los empleados
                    públicos que prestan sus servicios en la Administración
                    General de la Junta de Extremadura (DOE nº 225, de 23 de
                    noviembre de 2021) y conforme a lo dispuesto en el Plan de
                    Valoración para la progresión en el sistema de carrera
                    profesional horizontal vigente, el/la empleado/a público
                    cuyos datos se expresan a continuación, solicita el
                    reconocimiento de nivel de carrera profesional horizontal
                    que corresponda.
                  </p>
                </div>
                <div className="datosPersonalesCarrera d-flex flex-column">


                  <div className="formulario">
                    { }
                    <Formik
                      enableReinitialize
                      initialValues={{
                        nombreBorrador: datos?.nombreBorrador
                          ? datos.nombreBorrador
                          : defaultDraftNameRef,
                        dni: datos?.dni === "" ? "" : datos?.dni,
                        nombre: datos?.nombre === "" ? "" : datos?.nombre,
                        ape1: datos?.ape1 === "" ? "" : datos?.ape1,
                        ape2: datos?.ape2 === "" ? "" : datos?.ape2,
                        domicilio: datos.domicilio,
                        cp: datos?.cp,
                        localidad: datos?.localidad,
                        provincia:
                          datos?.provincia === "" ? "" : datos?.provincia,
                        tlf: datos?.tlf === "" ? "" : datos?.tlf,
                        email: datos?.email === "" ? "" : datos?.email,
                        nivelSolicitado: datos?.nivelSolicitado || "",
                        funcionario: datos?.funcionario || "",
                        laboral: datos?.laboral || "",
                        a1: datos?.a1 ? datos?.a1 : false,
                        a2: datos?.a2 ? datos?.a2 : false,
                        a3: datos?.a3 ? datos?.a3 : false,

                        doe: datos?.doe?.map(item => typeof item === 'string' ? item : item.value || "") || [""],
                        formacion: datos?.formacion?.map(item => typeof item === 'string' ? item : item.value || "") || [""],
                        transferencia: datos?.transferencia?.map(item => typeof item === 'string' ? item : item.value || "") || [""],
                        participacion: datos?.participacion?.map(item => typeof item === 'string' ? item : item.value || "") || [""],
                        //-------------------------
                        fechaCreacion: datos.fechaCreacion,
                        creado: datos.creado,
                        fcreacion: datos.fCreacion,
                        fmodifica: datos.fmodifica,
                        modificado: datos.modificado
                      }}
                      validate={(valores) => {
                        const errores = {};
                        // if (nomBorrador !== "" && nomBorrador !== null) {
                        //   valores.nombreBorrador = nomBorrador
                        // }

                        if (
                          valores.nombreBorrador === null ||
                          valores.nombreBorrador === ""
                        ) {
                          errores.nombreBorrador = "Debe introducir un nombre de borrador.";
                        }
                        if (
                          valores.domicilio === null ||
                          valores.domicilio === ""
                        ) {
                          errores.domicilio = "Debe introducir un domicilio.";
                        }
                        if (valores.cp === null || valores.cp === "") {
                          errores.cp = "Debe introducir un Código Postal.";
                        }

                        if (
                          valores.cpostal &&
                          !/^((0?[1-9]|[1-4]\d|5[0-2])\d{3}|[A-Za-z0-9][A-Za-z0-9\s-]{1,10})$/.test(
                            valores.cpostal.toString()
                          )
                        ) {
                          errores.cp = "Código postal inválido.";
                        }

                        if (
                          valores.localidad === null ||
                          valores.localidad === ""
                        ) {
                          errores.localidad =
                            "Debe introducir una localidad.";
                        }
                        if (
                          valores.provincia === null ||
                          valores.provincia === ""
                        ) {
                          errores.provincia =
                            "Debe introducir una provincia.";
                        }
                        if (valores.tlf === null || valores.tlf === "") {
                          errores.tlf = "Debe introducir un teléfono.";
                        }
                        if (
                          !/\(?([0-9]{3})\)?([ -]?)([0-9]{3})\2([0-9]{3})$/.test(
                            valores.tlf
                          )
                        ) {
                          errores.tlf =
                            "Error al introducir el número de telefono.";
                        }
                        if (valores.email === null || valores.email === "") {
                          errores.email = "Debe introducir un email.";
                        }

                        if (
                          valores.email !== null &&
                          valores.email !== "" &&
                          !/^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(valores.email)
                        ) {
                          errores.email = "Correo electrónico no válido.";
                        }


                        if (!valores.nivelSolicitado) {
                          errores.nivelSolicitado = "Debe seleccionar un nivel.";
                        }

                        if (!valores.laboral && valores.laboral === "" && !valores.funcionario && valores.funcionario === "") {
                          errores.laboral = "Seleccione una opción, Funcionario/Interino o Laboral Fijo/Temporal.";
                        }

                        if (valores.laboral && valores.funcionario) {
                          errores.laboral = "Seleccione solamente una opción, Funcionario/Interino o Laboral Fijo/Temporal.";
                        }



                        setDisablePresentar(true);
                        return errores;
                      }}
                      onSubmit={(valores) => {

                        // 
                        const regex = /^([A-Z]?)(\d+)([A-Z])$/i;

                        const match = valores.dni.match(regex);

                        if (match) {
                          const [, inicial, numeros, letraFinal] = match;



                          valores.letiniiep = inicial.toUpperCase();
                          valores.dni = numeros;
                          valores.letfiniep = letraFinal.toUpperCase();
                        }

                        datos?.doe.filter(
                          (item) => item.value !== "" || item.value !== null
                        );
                        datos?.formacion.filter(
                          (item) => item.value !== "" || item.value !== null
                        );
                        datos?.transferencia.filter(
                          (item) => item.value !== "" || item.value !== null
                        );
                        datos?.participacion.filter(
                          (item) => item.value !== "" || item.value !== null
                        );

                        valores.doe = valores.doe
                          .filter(item => item.trim() !== "")
                          .map(item => ({ id: null, value: item }));

                        valores.formacion = valores.formacion
                          .filter(item => item.trim() !== "")
                          .map(item => ({ id: null, value: item }));

                        valores.transferencia = valores.transferencia
                          .filter(item => item.trim() !== "")
                          .map(item => ({ id: null, value: item }));

                        valores.participacion = valores.participacion
                          .filter(item => item.trim() !== "")
                          .map(item => ({ id: null, value: item }));

                        valores.codSolicitud = datos?.codSolicitud;


                        if (valores.tipo === "submit") {


                          if (borrador) {
                            setLoadingBotonSolicitar(true);
                            updateSolicitudPresentada(valores).then(
                              (data) => {

                                setShow({
                                  mensaje: true,
                                  content: data,
                                  tipo: "tituloModal",
                                  boton: "Aceptar ",
                                  destinoAviso: null,
                                  destinoCerrar: "/carrera",
                                  stateParams: {
                                    solPresentada: true,
                                    codSolicitud: datos?.codSolicitud,
                                  },
                                });
                                setLoadingBotonSolicitar(false);
                              }
                            );
                          } else {
                            setShow({
                              mensaje: true,
                              content: "¿Desea presentar la solicitud?",
                              tipo: "tituloModal",
                              funcion: presentar,
                              valorFuncion: valores,
                              aviso: true,
                              destinoAviso: null,
                              destinoCerrar: null,
                            });
                          }


                        }

                        if (valores.tipo === "borrador") {



                          if (params?.id) {


                            setLoadingBoton(true);
                            updateBorradorZ9(params?.id, valores, "z9").then((data) => {
                              setShow({
                                mensaje: true,
                                content: data,
                                tipo: "tituloModal",
                                // funcion: mantenerBorrador,
                                // valorFuncion:valores,
                                destinoCerrar: "/reconNivelCarrera",
                                destinoAviso: null,
                              });
                              obtenerBorrador(params.id, "z9").then((data) => {

                                setDatos(data)
                                setDatos((prevState) => ({
                                  ...prevState,
                                  dni: `${data.letiniiep ? data.letiniiep : ""}${data.dni}${data.letfiniep ? data.letfiniep : ""}`,
                                }));
                              })
                              setLoadingBoton(false);
                            });
                            setDatos(datos);
                            setDatos((prevState) => ({
                              ...prevState,
                              dni: `${datos.niep}${user.letniep}`,
                            }));
                            // Setter para que no se quede vacio el borrador y no tener que recargar
                            setBorrador(true);
                          } else {


                            setLoadingBoton(true);
                            // insertSolicitudReconocimiento(valores).then(
                            //   (data) => {
                            //     
                            //     setShow({
                            //       mensaje: true,
                            //       content: data,
                            //       tipo: "tituloModal",
                            //       // funcion: mantenerBorrador,
                            //       // valorFuncion:valores,
                            //       destinoCerrar: "/solicitudCarrera",
                            //       destinoAviso: null,
                            //     });
                            //     mantenerBorrador(valores);
                            //     setLoadingBoton(false);
                            //   }
                            // );

                            sendBorradorZ9(valores).then(
                              (data) => {

                                setShow({
                                  mensaje: true,
                                  content: data,
                                  tipo: "tituloModal",
                                  // funcion: mantenerBorrador,
                                  // valorFuncion:valores,
                                  destinoCerrar: "/reconNivelCarrera",
                                  destinoAviso: null,
                                });
                                mantenerBorrador(valores);
                                setLoadingBoton(false);
                              }
                            );

                            setDatos(datos);
                            setDatos((prevState) => ({
                              ...prevState,
                              dni: `${datos.niep}${user.letniep}`,
                            }));
                            // Setter para que no se quede vacio el borrador y no tener que recargar
                            setBorrador(true);
                          }
                        }
                        // mantenerBorrador(datos)
                      }}
                    >
                      {({ errors, values, setTouched, validateForm, setFieldValue }) => (
                        <>
                          <Form>
                            <>
                              <div>
                                <div className="descripcionSolicitud mx-4">
                                  <p className="fw-bold">Nombre del borrador <span className="rojo">*</span></p>
                                  <Field
                                    type="text"
                                    id="nombreBorrador"
                                    name="nombreBorrador"
                                    className="form-control"
                                    maxLength="60"
                                  />
                                  <ErrorMessage
                                    name="nombreBorrador"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.nombreBorrador}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="d-flex justify-content-between">
                                  {/* <Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"1. Datos personales"}
                        ></Titulo> */}

                                  <div className="subSubTituloSolicitud p-2 fw-bold">
                                    <h4 className="tituloCard noBg fs-5">1. Datos personales y Nivel de Carrera</h4>
                                  </div>

                                  <p className="p-3 text-third-1">Campo obligatorio *</p>
                                </div>
                                <div className="subSubTituloSolicitud p-2 fw-bold">
                                  <h4 className="tituloCard noBg fs-5">1.A) Datos Personales</h4>
                                </div>
                              </div>
                              <div className="formularioDatosPesonalesCarrera p-2">

                                <div className="dniDP m-2">
                                  <label htmlFor="dni">DNI:</label>
                                  <Field
                                    type="text"
                                    id="dni"
                                    name="dni"
                                    className="form-control"
                                    placeholder="DNI *"
                                    readOnly
                                    disabled
                                  />
                                  <ErrorMessage
                                    name="dni"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.dni}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="nombreDP m-2">
                                  <label htmlFor="nombre">Nombre:</label>
                                  <Field
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    className="form-control"
                                    placeholder="Nombre *"
                                    readOnly
                                    disabled
                                  />
                                  <ErrorMessage
                                    name="nombre"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.nombre}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="ape1DP m-2">
                                  <label htmlFor="ape1">
                                    Primer Apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="ape1"
                                    name="ape1"
                                    className="form-control"
                                    placeholder="Primer apellido *"
                                    readOnly
                                    disabled
                                  />
                                  <ErrorMessage
                                    name="ape1"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.ape1}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="ape2DP m-2">
                                  <label htmlFor="ape2">
                                    Segundo Apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="ape2"
                                    name="ape2"
                                    className="form-control"
                                    placeholder="Segundo apellido"
                                    disabled
                                  />
                                </div>
                                <div className="domicilioDP m-2">
                                  <label htmlFor="domicilio">
                                    Domicilio <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="domicilio"
                                    name="domicilio"
                                    className="form-control"
                                    placeholder="Domicilio *"
                                    maxLength="149"
                                  />
                                  <ErrorMessage
                                    name="domicilio"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.domicilio}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="localidadCPDP m-2">
                                  <label htmlFor="localidad">
                                    Localidad <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="localidad"
                                    name="localidad"
                                    className="form-control"
                                    placeholder="Localidad *"
                                    maxLength="99"
                                  />
                                  <ErrorMessage
                                    name="localidad"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.localidad}
                                      </div>
                                    )}
                                  />
                                  <label className="mt-2" htmlFor="cp">
                                    CP <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="cp"
                                    name="cp"
                                    className="form-control"
                                    placeholder="CP *"
                                    maxLength="5"
                                    onKeyDown={(e) => {
                                      const allowedKeys = ["Backspace", "Delete"];
                                      if (allowedKeys.includes(e.key)) return;

                                      if (e.key === " ") e.preventDefault();
                                      if (/[a-zA-Z]/.test(e.key)) e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      // Permitir borrar
                                      const cleaned = e.target.value.replace(/[^\d]/g, "");
                                      setFieldValue("cp", cleaned);
                                    }}
                                  />
                                  <ErrorMessage
                                    name="cp"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.cp}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="provinciaDP m-2">
                                  <label htmlFor="provincia">
                                    Provincia <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="provincia"
                                    name="provincia"
                                    className="form-control"
                                    placeholder="Provincia *"
                                    maxLength="99"
                                  />
                                  <ErrorMessage
                                    name="provincia"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.provincia}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="tlfContactoDP m-2">
                                  <label htmlFor="tlf">
                                    Teléfono de contacto{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="tlf"
                                    name="tlf"
                                    className="form-control"
                                    placeholder="Teléfono de contacto *"
                                    maxLength="9"
                                    onKeyDown={(e) => {
                                      const allowedKeys = ["Backspace", "Delete"];
                                      if (allowedKeys.includes(e.key)) return;

                                      if (e.key === " ") e.preventDefault();
                                      if (/[a-zA-Z]/.test(e.key)) e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      // Permitir borrar
                                      const cleaned = e.target.value.replace(/[^\d]/g, "");
                                      setFieldValue("tlf", cleaned);
                                    }}
                                  />
                                  <ErrorMessage
                                    name="tlf"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.tlf}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="emailDP m-2">
                                  <label htmlFor="email">
                                    Correo electrónico de contacto{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="Correo electrónico de contacto *"
                                    maxLength="99"
                                  />
                                  <ErrorMessage
                                    name="email"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.email}
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                            </>
                            <div className="nivelCarreraSolicitado">
                              <div className="subSubTituloSolicitud p-2 fw-bold">
                                <h4 className="tituloCard noBg fs-5">1.B) Nivel de Carrera solicitado</h4>
                              </div>

                              <div className="nivelCarreraSolform">
                                <div className="nivelSol p-3 row">
                                  <div className="col-md-2">
                                    <p className="fw-bold">Nivel solicitado<span className="rojo"> *</span>: </p>
                                  </div>
                                  <div className="d-flex justify-content-around col-md-6">
                                    <label>
                                      <Field
                                        type="radio"
                                        name="nivelSolicitado"
                                        value="1"
                                        className="form-check-input mx-2"
                                      />
                                      Nivel 1
                                    </label>
                                    <label>
                                      <Field
                                        type="radio"
                                        name="nivelSolicitado"
                                        value="2"
                                        className="form-check-input mx-2"
                                      />
                                      Nivel 2
                                    </label>
                                    <label>
                                      <Field
                                        type="radio"
                                        name="nivelSolicitado"
                                        value="3"
                                        className="form-check-input mx-2"
                                      />
                                      Nivel 3
                                    </label>
                                    <label>
                                      <Field
                                        type="radio"
                                        name="nivelSolicitado"
                                        value="4"
                                        className="form-check-input mx-2"
                                      />
                                      Nivel 4
                                    </label>
                                  </div>
                                  <ErrorMessage
                                    name="nivelSolicitado"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        Debe seleccionar un nivel.
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="funcionarioCarreraInterino p-3 row">
                                  <div className="col-md-3">
                                    <p className="fw-bold">Funcionario carrera/interino:</p>
                                  </div>
                                  <div className="selectFunc col-md-4">
                                    <Field
                                      as="select"
                                      id="funcionario"
                                      name="funcionario"
                                      className="form-select"
                                      disabled={disableCombo.funcionario}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // 👇 ESTA LÍNEA ES OBLIGATORIA PARA QUE FORMK MANTENGA EL VALOR
                                        setFieldValue("funcionario", value);

                                        // 👇 tus flags sin tocar los datos
                                        if (value !== "") {
                                          setDisableCombo({ funcionario: false, laboral: true });
                                        } else {
                                          setDisableCombo({ funcionario: false, laboral: false });
                                        }
                                      }}
                                    >


                                      <option value="">Seleccione...</option>
                                      {funCarreraInterino.map((tipo, i) => (
                                        <option value={tipo} key={i}>
                                          {tipo}
                                        </option>
                                      ))}
                                    </Field>
                                    {/* <ErrorMessage
                                        name="funcionario"
                                        component={() => (
                                          <div className="error rojo pt-2">
                                            Seleccione una opción.
                                          </div>
                                        )}
                                      /> */}
                                  </div>
                                </div>

                                <div className="laboralFijoTemp p-3 row">
                                  <div className="col-md-3">
                                    <p className="fw-bold">Laboral Fijo/Temporal: </p>
                                  </div>
                                  <div className="selectFunc col-md-4">
                                    <Field
                                      as="select"
                                      id="laboral"
                                      name="laboral"
                                      className="form-select"
                                      disabled={disableCombo.laboral}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // 👇 ESTA LÍNEA ES OBLIGATORIA PARA QUE FORMK MANTENGA EL VALOR
                                        setFieldValue("laboral", value);

                                        // 👇 tus flags sin tocar los datos
                                        if (value !== "") {
                                          setDisableCombo({ funcionario: true, laboral: false });
                                        } else {
                                          setDisableCombo({ funcionario: false, laboral: false });
                                        }
                                      }}
                                    >



                                      <option value="">Seleccione...</option>
                                      {labFijoTemporal.map((tipo, i) => (
                                        <option value={tipo} key={i}>
                                          {tipo}
                                        </option>
                                      ))}
                                    </Field>
                                    <ErrorMessage
                                      name="laboral"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.laboral}
                                        </div>
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="relacionMeritos">

                              {/* <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={
                                    "2. Relación de méritos para alcanzar la puntuación mínima necesaria para superar el proceso de valoración:"
                                  }
                                ></Titulo> */}
                              <div className="subSubTituloSolicitud p-2 fw-bold">
                                <h4 className="tituloCard noBg fs-5">2. Relación de méritos para alcanzar la puntuación mínima necesaria para superar el proceso de valoración:</h4>
                              </div>

                              <div className="meritosComprobar">

                                {/* <Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={
                                      "2.A) Méritos a comprobar de oficio:"
                                    }
                                  ></Titulo> */}
                                <div className="subSubTituloSolicitud p-2 fw-bold">
                                  <h4 className="tituloCard noBg fs-5">2.A) Méritos a comprobar de oficio:</h4>
                                </div>
                                <div className="p-2">
                                  <Field
                                    type="checkbox"
                                    id="a1"
                                    name="a1"
                                    className="form-check-input"
                                  />{" "}
                                  A.1- Formación continua recibida y docencia
                                  impartida en la Escuela de Administración
                                  Pública de Extremadura (EAP).
                                  <p>
                                    Formación certificada por la EAP que se
                                    deberá marcar si el/la solicitante quiere
                                    que se le valore.
                                  </p>
                                  <p className="fw-bold">
                                    NO SE APORTARÁ DOCUMENTACIÓN.
                                  </p>
                                  <Field
                                    type="checkbox"
                                    id="a2"
                                    name="a2"
                                    className="form-check-input"
                                  />{" "}
                                  A.2- Puestos de trabajo de especial
                                  desempeño.
                                  <p>
                                    Son aquellos puestos de trabajo que reunen
                                    alguna de las circunstancias establecidas
                                    en el Plan de Valoración.
                                  </p>
                                  <p className="fw-bold">
                                    NO SE APORTARÁ DOCUMENTACIÓN.
                                  </p>
                                  <Field
                                    type="checkbox"
                                    id="a3"
                                    name="a3"
                                    className="form-check-input gestion-check-input"
                                  />{" "}
                                  A.3- Participación en órganos de selección
                                  y/o provisión del personal de la
                                  Administración de la Junta de Extremadura.
                                  <p>
                                    Se valorará la participación en calidad de
                                    presidente/a, secretario/a, vocal o
                                    asesor/a de los órganos de selección y
                                    provisión de la Administración General de
                                    la Junta de Extremadura. La persona
                                    solicitante deberá indicar, en su caso, el
                                    DOE de su nombramiento o de la publicación
                                    de la convocatoria de provisión.
                                  </p>
                                  <p>
                                    La persona solicitante deberá indicar, en
                                    su caso, el DOE de su nombramiento o de la
                                    publicación de la convocatoria de
                                    provisión.
                                  </p>
                                  <p className="fw-bold">
                                    NO SE APORTARÁ DOCUMENTACIÓN.
                                  </p>
                                  <div className="d-flex flex-column">
                                    <label
                                      className="mt-2"
                                      htmlFor="doe"
                                    >
                                      DOE:
                                    </label>
                                    {/* {datos?.doe?.map((input, i) => (
                                      <div key={i}>
                                        {doeMostrar ? (
                                          <>

                                            <div className="d-flex">
                                              <input
                                                type="text"
                                                name="doe"
                                                // placeholder="DOE"
                                                className="form-control mt-2"
                                                id={input.id}
                                                defaultValue={input.value}
                                                onChange={(event) => {
                                                  input.value =
                                                    event.target.value;
                                                }}
                                              />
                                              <i
                                                className="fa-solid fa-remove fs-1 mx-2 text-third-1 px-3 pt-2 cursorPointer "
                                                title="Eliminar doe"
                                                aria-label="Eliminar doe"
                                                role="button"
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter" || e.key === " ") {
                                                    eliminarGeneral(
                                                      input.id,
                                                      setDoeMostrar,
                                                      datos.doe,
                                                      "doe"
                                                    );
                                                  }
                                                }}
                                                onClick={() => {
                                                  eliminarGeneral(
                                                    input.id,
                                                    setDoeMostrar,
                                                    datos.doe,
                                                    "doe"
                                                  );
                                                }}
                                              ></i>
                                            </div>
                                          </>
                                        ) : (
                                          <SpinnerCircleMini></SpinnerCircleMini>
                                        )}
                                      </div>
                                    ))}
                                    <br />
                                    <div onClick={() => {
                                      anadirInput(datos.doe);
                                    }}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === " ") {
                                          anadirInput(datos.doe);
                                        }
                                      }}
                                      title="Añadir sección DOE"
                                      aria-label="Añadir sección DOE"
                                      role="button"
                                    >

                                      <i className="fa-solid fa-add  mx-2 text-success  cursorPointer">
                                        <span className="text-success">
                                          <b>Añadir</b>
                                        </span>
                                      </i>

                                    </div> */}
                                    <FieldArray name="doe">
                                      {({ push, remove }) => (
                                        <div className="mb-3">

                                          {values.doe.map((_, i) => (
                                            <div key={i} className="d-flex align-items-center gap-2 mt-2">
                                              <Field
                                                type="text"
                                                name={`doe[${i}]`}
                                                className="form-control"
                                                maxLength="66"
                                              />
                                              <i
                                                className="fa-solid fa-xmark text-danger cursorPointer fs-1"
                                                onClick={() => remove(i)}
                                                title="Borrar"
                                              ></i>
                                            </div>
                                          ))}
                                          {values.doe.length < 6 && (
                                            <div
                                              className="mt-2 cursorPointer"
                                              onClick={() => push("")}
                                            >
                                              <i className="fa-solid fa-add mx-2 text-success"></i>
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </FieldArray>
                                  </div>
                                </div>
                              </div>
                              <div className="meritosAcreditados">

                                {/* <Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={
                                      "2.B)  Méritos que deben ser acreditados por el/la interesado/a:"
                                    }
                                  ></Titulo> */}
                                <div className="subSubTituloSolicitud p-2 fw-bold">
                                  <h4 className="tituloCard noBg fs-5">2.B)  Méritos que deben ser acreditados por el/la interesado/a:</h4>
                                </div>
                                <p className="textoInfo p-2">
                                  {/* Si la persona solicitante cumplimenta alguno
                                  de estos apartados, deberá describir el
                                  mérito alegado, imprimir esta solicitud y
                                  enviarla, junto con los correspondientes
                                  certificados acreditativos, a la Dirección
                                  General de Función Pública, a través de
                                  alguno de los registros administrativos
                                  habilitados al efecto. En el caso de la
                                  formación continua y docencia el certificado
                                  deberá indicar el número de créditos/horas,
                                  en caso contrario, no serán objeto de
                                  valoración. */}
                                  Si la persona solicitante cumplimenta alguno de estos apartados, 
                                  deberá describir el mérito alegado, adjuntando digitalmente junto 
                                  a la solicitud electrónica los justificantes en formato PDF mediante 
                                  el botón “Documentación” de la solicitud electrónica. En el caso de la 
                                  formación continua y docencia, el certificado deberá indicar el número 
                                  de créditos/horas, en caso contrario, no serán objeto de valoración.
 
                                </p>
                                <div className="formacion">

                                  {/* <Titulo
                                      clases={
                                        "subSubTituloSolicitud p-2 fw-bold"
                                      }
                                      tipo={"tituloCard noBg"}
                                      titulo={
                                        "B.1.- Formación (no impartida por la EAP):"
                                      }
                                    ></Titulo> */}
                                  <div className="subSubTituloSolicitud p-2 fw-bold">
                                    <h4 className="tituloCard noBg fs-5">B.1.- Formación (no impartida por la EAP):</h4>
                                  </div>
                                  <div className="d-flex flex-column p-2">

                                    <FieldArray name="formacion">
                                      {({ push, remove }) => (
                                        <div className="mb-3">
                                          {values.formacion.map((_, i) => (
                                            <div key={i} className="d-flex align-items-center gap-2 mt-2">
                                              <Field
                                                type="text"
                                                name={`formacion[${i}]`}
                                                className="form-control"
                                                maxLength="78"
                                              />
                                              <i
                                                className="fa-solid fa-xmark text-danger cursorPointer fs-1"
                                                onClick={() => remove(i)}
                                                title="Borrar"
                                              ></i>
                                            </div>
                                          ))}
                                          {values.formacion.length < 7 && (
                                            <div
                                              className="mt-2 cursorPointer"
                                              onClick={() => push("")}
                                            >
                                              <i className="fa-solid fa-add mx-2 text-success"></i>
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </FieldArray>
                                  </div>
                                </div>
                                <div className="trasnferencia">

                                  {/* <Titulo
                                      clases={
                                        "subSubTituloSolicitud p-2 fw-bold"
                                      }
                                      tipo={"tituloCard noBg"}
                                      titulo={
                                        "B.2.- Transferencia, innovacion y difusión de conocimientos:"
                                      }
                                    ></Titulo> */}
                                  <div className="subSubTituloSolicitud p-2 fw-bold">
                                    <h4 className="tituloCard noBg fs-5">B.2.- Transferencia, innovacion y difusión de conocimientos:</h4>
                                  </div>
                                  <div className="d-flex flex-column p-2">
                                    <FieldArray name="transferencia">
                                      {({ push, remove }) => (
                                        <div className="mb-3">
                                          {values.transferencia.map((_, i) => (
                                            <div key={i} className="d-flex align-items-center gap-2 mt-2">
                                              <Field
                                                type="text"
                                                name={`transferencia[${i}]`}
                                                className="form-control"
                                                maxLength="78"
                                              />
                                              <i
                                                className="fa-solid fa-xmark text-danger cursorPointer fs-1"
                                                onClick={() => remove(i)}
                                                title="Borrar"
                                              ></i>
                                            </div>
                                          ))}
                                          {values.transferencia.length < 5 && (
                                            <div
                                              className="mt-2 cursorPointer"
                                              onClick={() => push("")}
                                            >
                                              <i className="fa-solid fa-add mx-2 text-success"></i>
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </FieldArray>
                                  </div>
                                </div>
                                <div className="participacion">

                                  {/* <Titulo
                                      clases={
                                        "subSubTituloSolicitud p-2 fw-bold"
                                      }
                                      tipo={"tituloCard noBg"}
                                      titulo={
                                        "B.3.- Participación en tribunales de las corporaciones locales en calidad de representante de la Administración General de la Junta de Extremadura."
                                      }
                                    ></Titulo> */}
                                  <div className="subSubTituloSolicitud p-2 fw-bold">
                                    <h4 className="tituloCard noBg fs-5">B.3.- Participación en tribunales de las corporaciones locales en calidad de representante de la Administración General de la Junta de Extremadura.  </h4>
                                  </div>
                                  <p className="textoInfo p-2">
                                    La persona solicitante deberá indicar el
                                    BOP de su nombramiento.
                                  </p>
                                  <div className="d-flex flex-column p-2">
                                    <FieldArray name="participacion">
                                      {({ push, remove }) => (
                                        <div className="mb-3">
                                          {values.participacion.map((_, i) => (
                                            <div key={i} className="d-flex align-items-center gap-2 mt-2">
                                              <Field
                                                type="text"
                                                name={`participacion[${i}]`}
                                                className="form-control"
                                                maxLength="78"
                                              />
                                              <i
                                                className="fa-solid fa-xmark text-danger cursorPointer fs-1"
                                                onClick={() => remove(i)}
                                                title="Borrar"
                                              ></i>
                                            </div>
                                          ))}
                                          {values.participacion.length < 4 && (
                                            <div
                                              className="mt-2 cursorPointer"
                                              onClick={() => push("")}
                                            >
                                              <i className="fa-solid fa-add mx-2 text-success"></i>
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </FieldArray>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="footer">
                              <p className="p-2">
                                En cumplimiento de lo dispuesto en la Ley
                                Orgánica 3/2018, de 5 de diciembre, de
                                protección de datos personales y garantía de
                                los derechos digitales, la Consejería de
                                Hacienda y Administración Pública le informa
                                que los datos de carácter personal recogidos
                                en esta solicitud van a ser tratados con la
                                finalidad de que le sea reconocido el nivel de
                                carrera profesional horizontal que
                                corresponda. El responsable del tratamiento de
                                estos datos será la Consejería de Hacienda y
                                Administración Pública. Las personas
                                interesadas podrán ejercitar los derechos de
                                acceso, rectificación, cancelación, supresión,
                                limitación del tratamiento y oposición
                                establecidos en los artículos 12 a 18 de la
                                referida Ley Orgánica, mediante escrito
                                dirigido a la Dirección General de Función
                                Pública (Avda. Valhondo s/n, Edificio III
                                Milenio, Módulo 1- 1ª planta. 06800 - MÉRIDA)
                              </p>
                              <div className="direccion d-flex flex-column align-items-center m-2 text-center">
                                <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
                                <p className="text-center">
                                  Avda. Valhondo, s/n Edificio III Milenio -
                                  Módulo 1 - 1ª Planta - 06800 Mérida
                                </p>
                              </div>
                            </div>
                            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 mb-1">
                              <button
                                id="guardarSolicitudCarrera"
                                className="btnRed botonVolverBorradorz9 rounded btnCancelar btnVolver order-2 order-md-1 w-25"
                                type="button"
                                onClick={() =>
                                  setShow({
                                    mensaje: true,
                                    content:
                                      "¿Deseas cancelar el formulario?",
                                    tipo: "tituloModal",
                                    aviso: true,
                                    destinoAviso: "/reconNivelCarrera",
                                    destinoCerrar: null,
                                  })
                                }
                              >
                                <i className="fa-solid fa-rotate-left"></i>{" "}
                                Volver
                              </button>
                              {accesoConcurso ? (
                                <>
                                  <button
                                    id="grabarSolicitudCarrera"
                                    className="btn botonGuardarBorradorz9 rounded btnPresentar order-1 order-md-2 w-25 px-5"
                                    type="button"
                                    onClick={async () => {
                                      // ✅ Forzamos validación en el primer click
                                      setTouched({
                                        nombreBorrador: true,
                                        domicilio: true,
                                        cp: true,
                                        localidad: true,
                                        provincia: true,
                                        tlf: true,
                                        email: true,
                                        nivelSolicitado: true,
                                        laboral: true,
                                        funcionario: true
                                      });

                                      const formErrors = await validateForm();

                                      if (Object.keys(formErrors).length === 0) {
                                        // No hay errores -> marcamos tipo y hacemos submit real
                                        values.tipo = "borrador";
                                        document
                                          .querySelector("form")
                                          .dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
                                      } else {
                                        // Hay errores -> mostramos modal
                                        setShow({
                                          mensaje: true,
                                          content:
                                            "Debe completar correctamente los datos obligatorios.",
                                          tipo: "tituloModal rojo",
                                          destinoCerrar: null,
                                          destinoAviso: null,
                                        });
                                      }
                                    }}
                                    disabled={
                                      borrador === false &&
                                      !disablePresentar &&
                                      loadingBoton
                                    }
                                  >
                                    {/* {} */}
                                    {loadingBoton ? (
                                      <div className="d-flex justify-content-center ">
                                        <SpinnerCircleMini />
                                      </div>
                                    ) : (
                                      <>
                                        <i className="fa-solid fa-save"></i>{" "}
                                        Guardar
                                      </>
                                    )}
                                  </button>
                                </>
                              ) : null}
                            </div>
                          </Form>
                        </>
                      )}
                    </Formik>
                  </div>
                </div>

              </div>
            </div>
          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              {/* {estado ? (
                    <>
                      {estadoError}
                      <Button
                        id="btnCerrarConsultaIRPF"
                        clases="btn-card mt-3"
                        nombre="Volver"
                        tipo="button"
                        funcion={() => {
                          navigate("/home");
                        }}
                      />
                    </>
                  ) : (
                    <SpinnerCircle></SpinnerCircle>
                  )} */}
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          content={show.content}
          tipo={show.tipo}
          aviso={show.aviso}
          destinoAviso={show.destinoAviso}
          funcion={show.funcion}
          valorFuncion={show.valorFuncion}
          boton={show.boton}
          destinoCerrar={show?.destinoCerrar}
          stateParams={show?.stateParams}
        ></ModalMensajes>
      ) : null}
    </>
  );
};
export default SolicitudCarrera;
